<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="750px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-if="!justAdd">
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="svcProviderPermissions && svcProviderPermissions.edit"
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar prestador de serviço</span>
      </v-tooltip>
      <v-tooltip bottom v-if="justAdd">
        <template v-slot:activator="{ on }">
          <v-btn
            @click="openForm()"
            v-on="on"
            fab
            dark
            small
            class="verySmall ml-0"
            color="light-blue darken-4"
          >
            <v-icon dark style="font-size:16px;">add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar prestador de serviço</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >{{formData.id ? 'Editar prestador de serviço' : 'Novo prestador de serviço'}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-form ref="svcProviderForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm6>
                <v-text-field
                  :disabled="viewForm"
                  v-model="formData.name_fantasy"
                  label="Nome da empresa"
                  :rules="$store.state.formRules.required"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm6 pl-4>
                <v-text-field
                  :mask="formData.cnpj.length <= 11 ? '###.###.###-########' : '##.###.###/####-##'"
                  :rules="$store.state.formRules.cpfCnpjRules"
                  v-model="formData.cnpj"
                  label="CPF/CNPJ"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <AddressSvcProvider
              class="addressAddressSvcProvider"
              :loadAddress="(data) => loadAddress(data)"
              :forwShow="dialogShow"
              :editedData="addressData"
            />
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AddressSvcProvider from '../../common/AddressForm'
const defaultForm = {
  name_fantasy: '',
  cnpj: '',
  address: {
    number_address: '',
    address_id: '',
    type: '',
    zipcode: '',
    address: '',
    district: '',
    state: '',
    city: '',
    complement: ''
  }
}
export default {
  name: 'svcProvidersForm',
  components: { AddressSvcProvider },
  props: {
    justAdd: Boolean,
    openForm: Function,
    closeForm: Function,
    saveSvcProvider: Function,
    dialog: Boolean,
    editFormData: Object
  },
  data: function () {
    return {
      viewForm: false,
      permissionsList: [],
      formData: { ...defaultForm },
      addressData: { ...defaultForm.address },
      validForm: true
    }
  },
  computed: {
    dialogShow () {
      return this.dialog
    },
    svcProviderPermissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  watch: {
    dialogShow: function (val) {
      if (val) {
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true
          } else {
            this.viewForm = false
          }
          this.formData = {
            ...this.editFormData
          }
          this.addressData = { ...this.editFormData.address }
        }
      } else {
        this.viewForm = false
        this.$refs.svcProviderForm.resetValidation()
        this.formData = { ...defaultForm }
        this.addressData = { ...defaultForm.address }
      }
    }
  },
  mounted () {
    // this.getPermissions();
  },
  methods: {
    loadAddress (data) {
      let obj = {
        district: data.bairro,
        zipcode: data.cep,
        city: data.localidade,
        address: data.logradouro,
        state: data.uf
      }
      this.addressData = { ...obj }
    },
    addOrRemovePermission (id) {
      // console.log(id);
    },
    getPermissions () {
      let obj = {
        url: '/api/permission',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.permissionsList = response.data
      })
    },
    resetDialog () {
      this.$props.closeForm()
    },
    doSave () {
      if (!this.$refs.svcProviderForm.validate()) {
        return
      }
      this.formData.address = this.addressData
      const callback = function () {
        this.$props.closeForm()
      }
      this.$props.saveSvcProvider(this.formData, callback)
    }
  }
}
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
</style>
